import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { StoreContext } from '../../contexts/ShopifyStoreContext'

const Indicator = styled.span`
  ${tw`ml-1`}
`

export default function CartIndicator() {
  const { checkout } = React.useContext(StoreContext)

  const items = checkout ? checkout.lineItems : []

  const quantity = items.reduce((total, item) => total + item.quantity, 0)

  return <Indicator>{quantity}</Indicator>
}
